<template>
  <a-card :bordered="false">
    <a-row :gutter="24" style="margin-bottom: 2vh;">
      <a-col :md="12" :sm="24" style="margin-bottom: 2vh;">
        <a-input-group v-if="isAdmin" compact>
          <a-select
            placeholder="键入名字选择企业"
            :allowClear="true"
            :filterOption="false"
            class="forty"
            showSearch
            @search="loadCorps"
            @change="corpSelectedChange"
            :notFoundContent="corpLoading ? undefined : '没有符合的企业'">
            <a-spin v-if="corpLoading" slot="notFoundContent" size="small"/>
            <a-select-option v-for="item in corps" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
          <a-input-search
            v-model="query.keyword"
            placeholder="输入姓名/账号/手机号码进行搜索"
            enterButton
            class="sixty"
            @search="handleSearch">
          </a-input-search>
        </a-input-group>
        <a-input-search
          v-else
          v-model="query.keyword"
          placeholder="输入姓名/账号/手机号码进行搜索"
          enterButton
          @search="handleSearch">
        </a-input-search>
      </a-col>
      <a-col :md="8" :sm="24">
        <a-button type="primary" @click="handleCreate">新建用户</a-button>
      </a-col>
    </a-row>

    <a-table
      :loading="loading"
      :rowSelection="rowSelection"
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="page.content"
      :pagination="pagination"
      @change="handleTableChange">
      <template slot="name" slot-scope="text, record">
        <router-link to="#">{{ record.realname }}</router-link>
      </template>
      <template slot="enabled" slot-scope="text, record">
        <a-tag :color="record.enabled ? 'green':'red'">{{ record.enabled ? '启用':'禁用' }}</a-tag>
      </template>
      <span slot="action" slot-scope="text, record">
        <a-popconfirm v-if="record.enabled" @confirm="handleEnable(record)" okText="确定" cancelText="取消">
          <a-icon slot="icon" type="question-circle-o"/>
          <template slot="title">
            <p>确定要禁用这个用户吗？</p>
          </template>
          <a href="javascript:;">禁用</a>
        </a-popconfirm>
        <a-popconfirm v-else @confirm="handleEnable(record)" okText="确定" cancelText="取消">
          <a-icon slot="icon" type="question-circle-o"/>
          <template slot="title">
            <p>确定要启用这个用户吗？</p>
          </template>
          <a href="javascript:;">启用</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a href="javascript:;" @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm @confirm="handleRemove(record.id)" okText="确定" cancelText="取消">
          <a-icon slot="icon" type="question-circle-o" style="color: red"/>
          <template slot="title">
            <p>确定要删除这个用户吗？</p>
            <i>(该操作不可撤销)</i>
          </template>
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <user-creation-from
      :visible.sync="visible.create"
      :roles="roles"
      :is-admin="isAdmin"
      :corp-id="userInfo().corpId"
      ref="cf"
      @onCreated="onCreated"/>
    <user-edit-form
      :visible.sync="visible.edit"
      :roles="roles"
      :is-admin="isAdmin"
      ref="form"
      @onUpdated="onUpdated"
      @onPasswordRestored="onPasswordRestored"/>

    <a-modal
      :visible="visible.result"
      title="操作成功"
      @cancel="visible.result=false">
      <template slot="footer">
        <a-button key="back" @click="visible.result=false">我知道了</a-button>
      </template>
      <result title="密码已重置" :is-success="true" description="请牢记下方密码，系统不会为您保存该密码">
        <div class="information">
          <a-row :gutter="12">
            <a-col :sm="0" :xs="24">新密码：</a-col>
            <a-col :sm="7" :xs="0" class="label">新密码：</a-col>
            <a-col :sm="17" :xs="24" class="ticket">
              {{ newPass }}
              <a-tooltip placement="bottomLeft" class="copy">
                <template slot="title">
                  <span>复制密码</span>
                </template>
                <a-button size="small" shape="circle" icon="copy" v-clipboard:copy="newPass" v-clipboard:success="onCopy"/>
              </a-tooltip>
            </a-col>
          </a-row>
        </div>
      </result>
    </a-modal>
  </a-card>
</template>

<script>
import { convertToPagination } from '@/utils/util'
import { pageUser, setEnabled, removeUser, listRoles } from '@/api/user'
import { pageCorp } from '@/api/corp'
import UserCreationFrom from './form/UserCreationForm'
import UserEditForm from './form/UserEditForm'
import { Result } from '@/components'
import { mapGetters } from 'vuex'

const columns = [
  {
    title: '姓名',
    dataIndex: 'realname',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '账号',
    dataIndex: 'username'
  },
  {
    title: '企业',
    dataIndex: 'corpName'
  },
  {
    title: '手机号码',
    dataIndex: 'mobile'
  },
  {
    title: '状态',
    dataIndex: 'enabled',
    scopedSlots: { customRender: 'enabled' }
  },
  {
    title: '上次登录',
    dataIndex: 'gmtLastSignIn'
  },
  {
    title: '注册时间',
    dataIndex: 'gmtCreate'
  },
  {
    title: '操作',
    dataIndex: 'action',
    // width: '150px',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'UserManager',

  components: { UserCreationFrom, UserEditForm, Result },

  data () {
    return {
      columns,
      loading: false,
      corpLoading: false,
      visible: {
        create: false,
        edit: false,
        result: false
      },
      query: {
        corpId: '',
        keyword: '',
        prop: '',
        direction: '',
        pageSize: 10,
        pageNumber: 0
      },
      page: {
        content: [],
        empty: false,
        first: true,
        last: true,
        number: 1,
        numberOfElements: 1,
        size: 1,
        sort: {},
        totalElements: 1,
        totalPages: 1
      },
      pagination: {
        current: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      selectedRowKeys: [],
      selectedRows: [],
      corps: [],
      roles: [],
      newPass: ''
    }
  },

  computed: {
    isAdmin () {
      return this.userInfo().roles.indexOf('管理员') > -1 || this.userInfo().roles.indexOf('运维工程师') > -1
    },
    rowSelection () {
      const ctx = this
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          ctx.unitIds = selectedRowKeys
          console.log(ctx.unitIds)
        }
      }
    }
  },

  mounted () {
    this.fetchData()
    this.loadRoles()
    this.loadCorps()
  },

  methods: {
    ...mapGetters(['userInfo']),
    fetchData () {
      this.loading = true
      pageUser(this.query).then(response => {
        this.page = response.data
        this.pagination = convertToPagination(this.page, this.pagination)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },

    handleSearch () {
      this.query.pageNumber = 0
      this.fetchData()
    },

    loadCorps (val) {
      this.corpLoading = true
      const query = {
        name: val,
        pageSize: 50,
        pageNumber: 0
      }
      pageCorp(query).then(response => {
        this.corps = response.data.content
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.corpLoading = false
      })
    },

    loadRoles () {
      listRoles().then(response => {
        this.roles = response.data
        if (!this.isAdmin) {
          this.roles = this.roles.filter(role => role === '企业管理员' || role === '企业用户')
        }
      }).catch(err => {
        console.log(err)
      })
    },

    corpSelectedChange (val) {
      this.query.corpId = val
      this.query.pageNumber = 0
      this.fetchData()
    },

    handleEnable (record) {
      this.loading = true
      setEnabled(record.id, !record.enabled).then(response => {
        this.$message.success(response.msg)
        record.enabled = !record.enabled
      }).catch(err => {
        console.log(err)
        this.$message.success(err.msg)
      }).finally(() => {
        this.loading = false
      })
    },

    handleCreate () {
      this.visible.create = true
      setTimeout(() => {
        this.$refs.cf.onLoad()
      }, 50)
    },

    onCreated () {
      this.fetchData()
    },

    onUpdated () {
      this.fetchData()
    },

    handleEdit (record) {
      this.visible.edit = true
      setTimeout(() => {
        this.$refs.form.onLoad(record)
      }, 50)
    },

    handleRemove (id) {
      this.loading = true
      removeUser(id).then(response => {
        this.$message.success(response.msg)
        this.fetchData()
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    handleTableChange (pagination, filters, sorter) {
      this.query.pageNumber = pagination.current - 1
      this.query.pageSize = pagination.pageSize
      this.fetchData()
    },

    onPasswordRestored (val) {
      this.newPass = val
      this.visible.result = true
    },

    onCopy () {
      this.$message.success('号码已复制到剪贴板')
    }
  }
}
</script>

<style lang="less" scoped>
  .forty {
    width: 40%;
  }

  .sixty {
    width: 60%;
  }

  .information {
    line-height: 22px;

    .ant-row:not(:last-child) {
      margin-bottom: 24px;
    }

    .label {
      text-align: right;
    }

    .ticket {
      color: #1890ff;
    }

    .copy {
      margin-left: 1vh;
    }
  }
</style>
